import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import _ from 'lodash';
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { trips } from "../../../../../../redux/trips/action";
import { selectTripsListItems } from "../../../../../../redux/trips/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import { paymentStatus } from "../../../../../../redux/payment-status/action";
import storePersist from "../../../../../../redux/storePersist";
import { selectAgentStatusUpdatedItem } from "../../../../../../redux/agent-status/selector";
import { agentStatus } from "../../../../../../redux/agent-status/action";
import { agentLocationTrackers } from "../../../../../../redux/agent-location-tracker/action";
import { toast } from "react-toastify";
import { selectPaymentStatusUpdatedItem } from "../../../../../../redux/payment-status/selector";

const TransportAgentTrips = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const libraryData = useSelector(selectListItems)
    const [pageSize, setPageSize] = useState(10);
    const [pageData, setPageData] = useState(1)
    const [isLocation, setIsLocation] = useState<boolean>(false)
    const [location, setLocation] = useState<any>([])
    const itemsData = useSelector(selectTripsListItems)
    const updateStatus = useSelector(selectAgentStatusUpdatedItem)
    const PaymentUpdateStatus = useSelector(selectPaymentStatusUpdatedItem)
    const userProfileId = storePersist.get("accessTokenMetadata").current.TokenMetadata.UserMetaData.UserProfileId

    const [
        columnDefs,
        setColumnDefs
    ] = useState({});

    const roleData = _.find(storePersist.get('userProfile')?.current?.items[0]?.Message?.Roles, ['Name', 'TransportAgent']);
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: `TransportAgentName`, headerName: 'Agent Name' },
            { field: `TransportAgentPhoneNo`, headerName: 'Agent PhoneNo' },
            { field: `fulfillments[0].start.location`, headerName: 'Pickup Address', isAddressFormat: true },
            { field: `fulfillments[0].end.location`, headerName: 'Drop Address', isAddressFormat: true },
            { field: `fulfillments[0].vehicle.vehicleType`, headerName: 'VehicleType' },
            { field: `fulfillments[0].vehicle.loading_capacity`, headerName: 'Vehicle Loading Capacity' },
            {
                field: 'PaymentMethodId',
                headerName: 'Payment Method',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentMethod },
                isRowColorDecider: true,
                sortable: true,
                filter: false
            },

            {
                field: `CargoTripsStatusId`, headerName: 'Trip status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTripsStatus }, isRowColorDecider: true
            },
            {
                field: `CargoOrderStatusId`, headerName: 'Order Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoOrderStatus }, isRowColorDecider: true
            },
            {
                field: `CargoTransportAgentStatusId`, headerName: 'Driver Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransportAgentStatus }, isCargoDriverEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoPickupStatusId`, headerName: 'Pickup Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoPickupStatus }, isCargoPickupEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoExceptionOrIssuesStatusId`, headerName: 'Exceptions/Issues Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoExceptionOrIssuesStatus }, isCargoIssuesEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoTransitStatusId`, headerName: 'Transit Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoTransitStatus }, isCargoTransitEditable: true, isRowColorDecider: true
            },
            {
                field: `CargoDeliveryStatusId`, headerName: 'Delivery Status', cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.CargoDeliveryStatus }, isCargoDeliveryEditable: true, isRowColorDecider: true
            },
            {
                field: 'PaymentStatusId',
                headerName: 'Payment Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.PaymentStatus },
                isRowColorDecider: true,
                sortable: true,
                filter: false,
                isPaymentEditble: true
            },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const handleEdit = (data: any) => {

        navigate(`${data?.Id}`)
    }
    const fetchTrips = () => {
        dispatch(trips.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/list`, entity: 'trips', jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "ModifiedOnUtc",
                "SortOrder": "desc",

                "Filters": [
                    {
                        "FieldName": "TransportAgentId",
                        "FilterOperatorId": 1,
                        "FieldValue": roleData?.Id,
                        "FieldType": "number"
                    }]
            }
        }))
    }
    const handleDelete = async (data: any) => {
        await dispatch(trips.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/trips/delete`,
            entity: 'trips',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        }))
        await fetchTrips()
    }


    const handleCargoDriverStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/agent-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoTransportAgentStatusId": event
                    }
                ]

            }
        }))
        if (event === 20) {
            setIsLocation(true)
        }

        await fetchTrips()
    };

    const captureLocation = () => {
        const deviceDetails = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language,
            appVersion: navigator.appVersion,
        };
        console.log('isLocation :', isLocation)
        console.log(deviceDetails)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    dispatch(agentLocationTrackers.create({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/agent-location-tracker`, entity: 'agentLocationTrackers', jsonData: {
                            Records: [
                                {
                                    "Context": {},
                                    "Message": {
                                        "AgentUserProfileId": userProfileId,
                                        "Latitude": latitude.toString(),
                                        "Longitude": longitude.toString(),
                                    }
                                }
                            ]
                        }
                    }))

                    console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
                    setLocation(
                        {
                            Latitude: latitude,
                            Longitude: longitude
                        }

                    )
                },
                (error) => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            console.error("User denied the request for Geolocation.");
                            alert("Please enable location services for this app in your browser settings.iOS device (Settings > Privacy > Location Services)");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            console.error("Location information is unavailable.");
                            alert("Location information is unavailable.");
                            break;
                        case error.TIMEOUT:
                            console.error("The request to get user location timed out.");
                            alert("The request to get user location timed out.");
                            break;

                    }
                },
                {
                    enableHighAccuracy: true,
                    maximumAge: 0
                }
            );
            //dispatch(updateAgentLocation({ section, field, payload: { isEdit: false, isVerifyButtonVisible: false, isDeleteButtonVisible: true, isSuccess: true } }));

        }
        else {
            console.error("Geolocation is not supported by this browser.");
            alert("Geolocation is not supported by this browser.");
        }
    };

    const agentStatusToaster = async () => {
        await toast.error(`${updateStatus?.result?.Error?.message}`)
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
    }

    useEffect(() => {

        if (updateStatus?.result?.Error?.code == 400) {
            agentStatusToaster()
        }
    }, [updateStatus]);

    useEffect(() => {
        if (isLocation && updateStatus?.isSuccess) {
            toast.info('Tracking is active.');
            captureLocation()
            // Set up the interval to fetch data every 30 seconds (30000 ms)
            const intervalId = setInterval(captureLocation, 30000);
            return () => clearInterval(intervalId);
        }
    }, [isLocation])

    const handleCargoDeliveryStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/delivery-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoDeliveryStatusId": event
                    }
                ]

            }
        }))
        if (event === 30) {
            toast.info('Tracking is Inactive.');
            setIsLocation(false)
        }
        await fetchTrips()
    };
    const handleCargoTransitStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/transit-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoTransitStatusId": event
                    }
                ]

            }
        }))
        await fetchTrips()
    };
    const handleCargoIssueStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/issue-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoExceptionOrIssuesStatusId": event
                    }
                ]

            }
        }))
        await fetchTrips()
    };
    const handleCargoPickupStatusClick = async (event: any, dataId: any) => {
        await dispatch(agentStatus.resetAction({ actionType: 'update' }))
        await dispatch(agentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/transport-agents/pickup-status`,
            entity: 'agentStatus',
            jsonData: {

                Context: {},
                Records: [
                    {
                        "Id": dataId?.fulfillments[0]?.agent?.id,
                        "TripsId": dataId?.Id,
                        "ShipmentId": dataId?.ShipmentId,
                        "CargoPickupStatusId": event
                    }
                ]

            }
        }))
        await fetchTrips()
    };

    const handlePaymentStatusClick = async (paymentValue: any, dataId: any) => {
        await dispatch(paymentStatus.resetAction({ actionType: 'update' }))
        await dispatch(paymentStatus.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/payment-status`,
            entity: 'paymentStatus', options: { notifyOnSuccess: false, notifyOnFailed: true },
            jsonData: {


                Records: [
                    {
                        context: {},
                        Message: {
                            ShipmentId: dataId?.ShipmentId,
                            PaymentStatusId: paymentValue?.PaymentStatusId,
                            PaidAmount: paymentValue?.PaidAmount
                        }
                    }
                ]


            }
        }))
        await fetchTrips()
    }

    const PaymentStatusToaster = async () => {
        await toast.error(PaymentUpdateStatus?.result?.Records[0]?.Error?.Message)
        await dispatch(paymentStatus.resetAction({ actionType: 'update' }))
    }

    useEffect(() => {
        if (PaymentUpdateStatus?.result?.Records[0]?.Error) {
            PaymentStatusToaster()
        }
    }, [PaymentUpdateStatus]);

    useEffect(() => {
        createColumnDefs()
        fetchTrips()
    }, [pageData, pageSize])


    return (
        <>
            {itemsData?.isLoading ? <PageLoader />
                :
                <Table columnData={columnDefs}
                    rowData={itemsData?.result?.items}
                    setPageData={setPageData} setPageSize={setPageSize}
                    onPaymentStatusClick={handlePaymentStatusClick}
                    onCargoDriverStatusClick={handleCargoDriverStatusClick}
                    onCargoDeliveryStatusClick={handleCargoDeliveryStatusClick}
                    onCargoTransitStatusClick={handleCargoTransitStatusClick}
                    onCargoIssueStatusClick={handleCargoIssueStatusClick}
                    onCargoPickupStatusClick={handleCargoPickupStatusClick}
                    paginationData={itemsData?.result?.pagination}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    headingName="Trips" />
            }
        </>

    );
};

export default TransportAgentTrips;


